module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "bonzi_map.2385468f.png" + "?" + Date.now();